
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/club/[club]/apply",
      function () {
        return require("private-next-pages/club/[club]/apply.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/club/[club]/apply"])
      });
    }
  